import { Typography } from '@sonnen/web-ui';
import { getLocale } from '@sonnen/web-utils';
import { useEffect, useRef, useState } from 'react';
import { useTranslation } from '../../i18n/i18n';

const UPDATE_INTERVAL = 25;

export const PriceTag = ({ value, size }: { value: number; size: 'Number2' | 'Number3' }) => {
  const [displayValue, setDisplayValue] = useState(value);
  const currentNumber = useRef(value);
  const { t } = useTranslation();

  useEffect(() => {
    const targetValue = value;
    const stepSize = (targetValue - currentNumber.current) / 10;

    const interval = setInterval(() => {
      currentNumber.current += stepSize;
      setDisplayValue(currentNumber.current);
      if (Math.round(currentNumber.current) == Math.round(targetValue)) {
        setDisplayValue(targetValue);
        clearInterval(interval);
      }
    }, UPDATE_INTERVAL);

    return () => clearInterval(interval);
  }, [value]);

  const NumberTypography = Typography[size];

  return (
    <>
      <NumberTypography>
        {displayValue.toLocaleString(getLocale(), {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })}
      </NumberTypography>
      <Typography.Label1>{`€/${t('offer.month')}`}</Typography.Label1>
    </>
  );
};
